"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const dated_columns_1 = require("../../../composite/evidence/dated-evidence/dated-columns");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const schedule_api_1 = require("../schedule-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { datedColumns } = (0, dated_columns_1.useDatedColumns)();
    return [
        {
            datakey: 'job',
            sortkey: 'job.name',
            filterkey: 'job.id',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_COLUMN_JOB',
                defaultMessage: 'Úloha',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(schedule_api_1.useJobsAll),
            valueMapper: table_cells_1.TableCells.dictionaryColumnMapper,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'state',
            sortkey: 'state.name',
            filterkey: 'state.id',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_COLUMN_STATE',
                defaultMessage: 'Stav',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(schedule_api_1.useRunStates),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(schedule_api_1.useRunStates),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'startTime',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_COLUMN_START_TIME',
                defaultMessage: 'Začátek',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'endTime',
            name: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_COLUMN_END_TIME',
                defaultMessage: 'Konec',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        ...datedColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=runs-columns.js.map